import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	btnAlign: {
		marginTop: '15px',
		float: 'right'
	},
	headerLeft: {
		float: 'left',
		fontSize: '20px'
	},
	marginLeft15: {
		marginLeft: '15px'
	},
	marginTop20: {
		marginTop: '20px'
	},
	cardContainer: {
		border: "1px solid #DFDFDF",
		boxSizing: "border-box",
		borderRadius: "4px"
	},
	searchWrapper: {
		paddingTop: "15px",
		marginLeft: "12px",
		marginRight: "10px",
		position: "relative"
	},
	chaptersDiv: {
		float: "left",
		padding: "10px",
		margin: "7px",
		borderRadius: "4px",
		border: "1px solid #DFDFDF",
		"&:hover": {
			background: "#efefef"
		},
		cursor: "pointer"
	},
	chaptersDivSelected:{
		backgroundColor: '#54a9fc' 
	},
	'chaptersDiv:hover': {
		backgroundColor: "blue"
	},
	breadCrumbs: {
		float: "left",
		padding: "10px",
		margin: "7px",
		borderRadius: "40px",
		border: "1px solid #DFDFDF",
		backgroundColor: "#DFDFDF",
		marginTop: "19px"
	},
	paper: {
		zIndex: 1,
		width: "100%",
		maxHeight: "200px"
	},
	// searchList: {
	// 	zIndex: 9999,
	// 	maxHeight: "250px",
	// 	overflowY: "scroll",
	// 	position: "absolute",
	// 	width: "100%",
	// 	marginTop: "-5px",
	// 	paddingBottom: "20px"
	// }
	tentativeDuration: {
		padding: `0 ${theme.spacing.unit * 2}px`,
	}
});
